import type { SxProps, Theme } from "@mui/material/styles";

export const MANAGEMENT_ACTION_ROW_SX: SxProps<Theme> = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 1,
  minHeight: "40px",
  alignItems: "center",
};

export const MANAGEMENT_ACTION_ICON_BUTTON_SIZE = "small" as const;
export const MANAGEMENT_ACTION_ICON_FONT_SIZE = "small" as const;
